import React from 'react';
import './Result.css';

export default function Result(props) {
    const length = 50; 
    const location = props.document.location
    const title= props.document.title
    const isNullText= props.document.text=== undefined || props.document.text === null;
    const text = isNullText ? "" : props.document.text;
    const words = isNullText ? [] : text.split(' ');
    const count = isNullText ? 0 : words.length;
    const elements = [];
    let tagHtml = ""
    let cssStyle = ""
    let position = 0;
    while (position < count) {
			    const text = words.slice(position, length).join(' ');
			    position += length;
			    elements.push((
			      text
			    ));
			  }
    if (location.includes('cloudoperations')) { 
       tagHtml = "Bizagi Operations Documentation";
       cssStyle = "tag1";	    
    }
    if (location.includes('bizagidocumentation')) { 
       tagHtml = "Bizagi Technical Documentation";      
       cssStyle = "tag2";	    	    
    }
    if (location.includes('bizagiknowledgebase')) { 
       tagHtml = "Internal KB";     
       cssStyle = "stylekbinternal";	    	    
    }
    if (location.includes('cs-bizagi')) { 
       tagHtml = "Tickets Platform";      
       cssStyle = "styleticket";	    	    
    }
    if (location.includes('kb.bizagi.com')) { 
       tagHtml = "External KB";     
       cssStyle = "stylekbexternal";	    	    
    }
    if (location.includes('bizagidevdocs')) { 
       tagHtml = "Bizagi Dev Docs";     
       cssStyle = "styleBizagiDevs";	    	    
    }
    if (location.includes('helper.bizagi.com')) { 
      tagHtml = "BizagiXPress";     
      cssStyle = "styleBizagiXPress";	    	    
   }
	
    return(
	    	<div className="resultBox">
	    		<label className="tag"><span className={cssStyle}>{tagHtml}</span></label> <a href={`http://${location}`} target="_blank" rel="noreferrer" ><h6 className="title-style">{title}</h6></a>
		 	{elements}...
			<br></br>
		</div>
    );
}	
	
	
